import React, { useState, useRef } from 'react';
import MediaList from './MediaList';
import MediaDetail from './MediaDetail';

const MediaManagement = () => {
    const [selectedMedia, setSelectedMedia] = useState(null);
    const mediaListRef = useRef(null);

    const handleMediaSelect = (media) => {
        setSelectedMedia(media);
    };

    const handleCloseDetail = () => {
        setSelectedMedia(null);
    };

    const handleMediaUpdated = () => {
        // Trigger a refresh in the MediaList component
        if (mediaListRef.current && typeof mediaListRef.current.refreshMedia === 'function') {
            mediaListRef.current.refreshMedia();
        }
    };

    return (
        <div className="flex flex-col h-full">
            <MediaList
                ref={mediaListRef}
                onMediaSelect={handleMediaSelect}
                selectedMedia={selectedMedia}
            />

            {selectedMedia && (
                <MediaDetail
                    media={selectedMedia}
                    onClose={handleCloseDetail}
                    onMediaUpdated={handleMediaUpdated}
                />
            )}
        </div>
    );
};

export default MediaManagement; 